<template>
  <div
    class="inline-block cursor-pointer break-all rounded-4 bg-white px-[6px] py-[10px] text-center text-[11px] font-bold leading-[13px] md:px-[10px] md:text-16 md:leading-5"
  >
    <slot />
  </div>
</template>
